import React, { FC } from "react";

export const PageTitle: FC = () => {
  return (
    <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-7 text-center">
      Find the right EU tariff rate for your product
    </h1>
  );
};
